import { memo } from "react";
import { Alert } from "@mui/material";
import { FieldTypeEditorProps } from "../types";

export const PepFieldTypeSpecificProps = memo(
  (_props: FieldTypeEditorProps) => (
    <Alert severity='info' sx={{ alignSelf: "flex-start" }}>
      The applicant PEP question and radio options are fixed. The label is used
      as the section heading, and the field name controls the stored boolean key.
    </Alert>
  ),
);
